import styled from '@emotion/styled'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FusionColor } from '../../../theme/FusionStyle'
import { faSquare } from '@fortawesome/pro-regular-svg-icons'

// typescript does not put together enums that use other enums properly
type V2L1SmallRoundIconBackgroundColor = (
	FusionColor.Second|
	FusionColor.Third
)

export enum V2L1SmallRoundIconSize {
	Small = 'small',
	VerySmall = 'verySmall',
}

interface V2L1SmallRoundIconRootProps {
	backgroundColor?: V2L1SmallRoundIconBackgroundColor
	size?: V2L1SmallRoundIconSize
	color?: FusionColor
}

const V2L1SmallRoundIconRoot = styled.div<V2L1SmallRoundIconRootProps>(({theme, backgroundColor, size, color}) => ({
	display: 'inline',
	boxSizing: 'border-box',
	borderRadius: '50%',
	backgroundColor: backgroundColor ? theme.colors[backgroundColor] : theme.colors.second,
	color: color ? theme.colors[color] : theme.colors.inputLabel,
	fontSize: `${14/16}rem`,
	padding: size === V2L1SmallRoundIconSize.VerySmall ? `${2/16}rem` : `${10/16}rem`,
}))

interface V2L1SmallRoundIconProps {
	icon?: IconProp
	backgroundColor?: V2L1SmallRoundIconBackgroundColor
	size?: V2L1SmallRoundIconSize
}

export const V2L1SmallRoundIcon = ({icon, backgroundColor, size}: V2L1SmallRoundIconProps) => {
	let color: FusionColor|undefined = undefined
	if(!icon) {
		icon = faSquare
		color = FusionColor.Transparent
	}
	return (
		<V2L1SmallRoundIconRoot backgroundColor={backgroundColor} size={size} color={color}>
			<FontAwesomeIcon fixedWidth={true} icon={icon} />
		</V2L1SmallRoundIconRoot>
	)
}

